interface String {
    appendIf(conditions: boolean, stringToAppend: string): string;
}

String.prototype.appendIf = function(conditions: boolean, stringToAppend: string): string {
    const s = this;
    if (conditions) {
        return s + stringToAppend;
    } else {
        return s as string;
    }
}


// WEBPACK FOOTER //
// ./src/utilities/StringExtensions.ts